import React, { useState } from 'react';
import { Language } from 'language/Language';
import { strings } from './strings';
import ProductDescription from '../productDescription/ProductDescription';
import Faq from '../faq/Faq';

const ProductBottom = () => {
  const [description, setDescription] = useState(true);
  const language = Language();
  return (
    <div>
      <div className='product-switch'>
        <h2 className={`switch-item ${description && 'switch-select'}`} onClick={() => setDescription(!description)}>{strings[language].description}</h2>
        <h2 className={`switch-item ${!description && 'switch-select'}`} onClick={() => setDescription(!description)}>{strings[language].faq}</h2>
      </div>
      {description
        ? (
          <ProductDescription />
        )
        : (
          <Faq />
        )}
    </div>
  );
};

export default ProductBottom;
